import { TIPTAP_PDF_STYLE_ADJUSTMENTS } from './pdfStyleAdjustments';

export const adjustBlockquoteElements = (clonedDoc: Document) => {
  const clonedBlockquote = clonedDoc.querySelectorAll('blockquote');
  clonedBlockquote.forEach(blockquote => {
    const element = blockquote as HTMLElement;
    element.style.borderLeft =
      TIPTAP_PDF_STYLE_ADJUSTMENTS.blockquote.borderLeft;
    element.style.margin = TIPTAP_PDF_STYLE_ADJUSTMENTS.blockquote.margin;
    element.style.paddingLeft =
      TIPTAP_PDF_STYLE_ADJUSTMENTS.blockquote.paddingLeft;
    // element.style.display = 'inline-block';
    element.style.opacity = '1';
    element.style.visibility = 'visible';

    Array.from(element.childNodes).forEach(childNode => {
      if (childNode.nodeType === Node.ELEMENT_NODE) {
        const childElement = childNode as HTMLElement;
        childElement.style.position = 'relative';
        childElement.style.top =
          TIPTAP_PDF_STYLE_ADJUSTMENTS.blockquote.childrenTop;
        childElement.style.left =
          TIPTAP_PDF_STYLE_ADJUSTMENTS.blockquote.childrenLeft;
      } else if (
        childNode.nodeType === Node.TEXT_NODE &&
        childNode.textContent?.trim()
      ) {
        const wrapper = clonedDoc.createElement('span');
        wrapper.style.position = 'relative';
        wrapper.style.top = TIPTAP_PDF_STYLE_ADJUSTMENTS.blockquote.childrenTop;
        wrapper.style.left =
          TIPTAP_PDF_STYLE_ADJUSTMENTS.blockquote.childrenLeft;

        // 텍스트 노드를 span으로 감싸기
        const parent = childNode.parentNode;
        if (parent) {
          parent.insertBefore(wrapper, childNode);
          wrapper.appendChild(childNode);
        }
      }
    });
  });
};
